import { writable } from 'svelte/store';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  duration?: number;
}

function createToastStore() {
  const { subscribe, update } = writable<Toast[]>([]);

  function add(type: ToastType, message: string, duration = 3000) {
    const id = crypto.randomUUID();
    update((toasts) => [...toasts, { id, type, message, duration }]);

    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }

    return id;
  }

  function remove(id: string) {
    update((toasts) => toasts.filter((t) => t.id !== id));
  }

  function success(message: string, duration?: number) {
    return add('success', message, duration);
  }

  function error(message: string, duration = 5000) {
    return add('error', message, duration);
  }

  function warning(message: string, duration?: number) {
    return add('warning', message, duration);
  }

  function info(message: string, duration?: number) {
    return add('info', message, duration);
  }

  return { subscribe, add, remove, success, error, warning, info };
}

export const toast = createToastStore();
